import { h } from "preact";
import styles from "./Page.css";

const Page = (props) => {
  return <div class={styles.page}>{props.children}</div>;
};

export default Page;
